import Axios, { AxiosRequestConfig } from 'axios';
import { circuitBreaker } from './circuitBreaker';
import { AXIOS_INSTANCE } from './axiosInstance';

// Re-export axios instance for backward compatibility
export { AXIOS_INSTANCE };

export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => {
  const source = Axios.CancelToken.source();

  // Queue the request with circuit breaker
  // Circuit breaker will make the axios call and resolve/reject the promise
  const promise = circuitBreaker.queueRequest({
    ...config,
    ...options,
    cancelToken: source.token,
  }) as Promise<T>;

  // @ts-ignore
  promise.cancel = () => {
    source.cancel('Query was cancelled');
  };

  return promise;
};

export default customInstance;
